import { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";

// Eager: critical first-paint route
import Home from "@/pages/Home";

// Lazy: split into separate chunks
const About = lazy(() => import("@/pages/About"));
const Work = lazy(() => import("@/pages/Work"));
const Packages = lazy(() => import("@/pages/Packages"));
const Reviews = lazy(() => import("@/pages/Reviews"));
const FAQ = lazy(() => import("@/pages/FAQ"));
const Booth = lazy(() => import("@/pages/Booth"));
const Contact = lazy(() => import("@/pages/Contact"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PageFallback() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-bde-cream">
      <div className="font-mono uppercase tracking-[0.22em] text-xs text-bde-ink/60">Loading…</div>
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<PageFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/work" element={<Work />} />
              <Route path="/packages" element={<Packages />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/booth" element={<Booth />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Suspense>
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                border: "2px solid #11100F",
                background: "#FDFBF7",
                color: "#11100F",
                fontFamily: "Outfit, sans-serif",
                boxShadow: "4px 4px 0px #11100F",
                borderRadius: 0,
              },
            }}
          />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
